import React from 'react';
import { Icon } from './Icon.js';
export const IconCornerRadiusFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "m2.75,16c-.4141,0-.75-.3359-.75-.75v-6.5c0-3.7222,3.0278-6.75,6.75-6.75h6.5c.4141,0,.75.3359.75.75s-.3359.75-.75.75h-6.5c-2.895,0-5.25,2.355-5.25,5.25v6.5c0,.4141-.3359.75-.75.75Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconCornerRadiusFill18.js.map